module.exports = __webpack_public_path__ + "img/incein-qr.6bb1b82a.jpg";